<template>
  <span>{{ documentTypeLabel }}</span>
</template>

<script>
import { getDocumentType } from '../dataAccess/documentTypes'

export default {
  name: 'DocumentTypeLabel',
  props: {
    documentType: { type: String, required: true }
  },
  computed: {
    documentTypeLabel() {
      return getDocumentType(this.documentType).label
    }
  }
}
</script>
